import React, { useEffect, useState } from "react";
import Cart from "../Cart";
import { Controller, useForm } from "react-hook-form";
import { PATTERNS } from "../../../util/patterns";
import { months, numberOfEmployees } from "../../../util/CommonLists";
import { useHistory } from "react-router-dom";
import { GetCountryListAndInternationalSupport } from "../../../util/countryListAndInternationalSupport";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import moment from "moment-timezone";
import * as common from "../../../util/common";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import LogoContainer from "../../common/LogoContainer";
import { updateState, FirstTermsStates } from "../StateManagement";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { isValidPhoneNo } from "../../../util/phoneNumberValidationUtil";
import * as services from "../../../store/service";
import { useButtonText } from "../../commonConstants";
import LegalDocumentContainer from "../../LegalDocumentPages/LegalDocumentContainer";
import { isIDFPartnerUser } from "../../../util/partner";
import { sendRequest } from "../../../util/httpClient";
import { Helmet } from "react-helmet";
import DeviceVerificationError from '../DeviceVerificationError';
interface IProps {
    setForm: any;
    displayData: any;
    registrationState: any;
    setRegistrationState: any;
    registrationLookup?: any;
    manage: any;
}

const PersonalInformationForm = ({ setForm, displayData, setRegistrationState, registrationState, registrationLookup, manage }: IProps) => {
    const userData = displayData.userData;
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const { register, handleSubmit, errors, watch, setError, setValue, getValues, clearErrors, control } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });
    let history = useHistory();
    let { supportInternational, getCountries } = GetCountryListAndInternationalSupport();
    const isBusinessUser = displayData && displayData.isBusinessUser;
    const hasTUProvider = displayData && displayData.isTUUser;
    const isExperianUser = displayData && displayData.isExperianUser;
    const hasCreditService = displayData && displayData.hasCreditService;
    // const isIDFPartner = useSelector((state: ApplicationState) =>
    //     state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
    //         ? state.configurationState.configuration.partnerConfig.isIdfPartner
    //         : false
    // );
    const isDisplayDomain = displayData && displayData.displayCompanyDomainName;
    const subscriberDetails = registrationLookup && registrationLookup["subscriberDetails"];
    const [idfMinimumAgeError, setIdfMinimumAgeError] = useState(false);
    const [idfFutureDateAgeError, setIdfFutureDateAgeError] = useState(false);
    const [showDeviceVerificationError, setShowDeviceVerificationError] = useState(false);
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const LookupType: any = query.get("Type");
    const tosAccepted: any = query.get("TOSAccepted");
    const isTOSAccepted = tosAccepted === "true";
    const [loading, setLoading] = useState(false);
    const [deviceVerificationStatus, setDeviceVerificationStatus] = useState(false);
    const { t: tLang } = useTranslation();
    const isTypeSSOProvisional = LookupType === "SSO_PROVISIONAL";
    const { getTermsOfUseURL, getPrivacyNoticeURL, getPrivacyNoticeLinkText, getTermsOfUseLinkText, getPersonalInfoLinkText, personalInformationLink } = LegalDocumentContainer();
    const isDynamicFooter: boolean = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isDynamicFooterAvailable
            ? state.configurationState.configuration.partnerConfig.isDynamicFooterAvailable
            : false
    );
    const Gndrll = query.get("GNDNRLL");
    const hasSontiqBrand = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasSontiqBrand
            ? state.configurationState.configuration.partnerConfig.hasSontiqBrand == "true"
                ? true
                : false
            : false
    );
    const maxAgeLimit = displayData.maxAgeLimit;
    const minAgeLimit = displayData.minAgeLimit;

    const showLogoOnRegistrationScreens: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.registration
            ? state.configurationState.configuration.partnerConfig.registration.includePartnerLogo
            : false
    );
    const ShowTermsAndConditionScreenFirst: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.registration
            ? state.configurationState.configuration.partnerConfig.registration.showTermsAndConditionScreenFirst
            : false
    );
    const IsWhiteLabeled: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );

    const allowSSORegistrationFlow = useSelector(
        (state: ApplicationState) =>
            (state.configurationState &&
                state.configurationState.configuration &&
                state.configurationState.configuration.partnerConfig &&
                state.configurationState.configuration.partnerConfig.ssoOptions &&
                state.configurationState.configuration.partnerConfig.ssoOptions.allowRegistrationFlow &&
                state.configurationState.configuration.partnerConfig.ssoOptions.allowRegistrationEmailUpdate) ||
            false
    );

    let defaultTncLink: string = "https://www.sontiq.com/terms-of-use/";
    const isIDFPartner = useSelector((state: ApplicationState) =>
        state.configurationState &&
            state.configurationState.configuration.partnerConfig.partnerId &&
            state.configurationState.configuration.partnerConfig.isIdfPartner
            ? !isIDFPartnerUser(state.configurationState.configuration.partnerConfig.partnerId)
            : false
    );
    const defaultCountryCode: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.defaultCountryCode
            ? state.configurationState.configuration.partnerConfig.defaultCountryCode.length > 0
                ? state.configurationState.configuration.partnerConfig.defaultCountryCode
                : "US"
            : "US"
    );
    const partnerDisplayName: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.partnerDisplayName
            : ""
    );
    const onPersonalInfoNext = (event: any) => {
        if (LookupType == "SSSOFFER" || LookupType == "WALKUP") {
            let proofInfo = registrationState.proofInfo;
            let prooftime = new Date().toISOString().replace(/T/, " ").replace(/\..+/, "");
            proofInfo.writtenInstruction = prooftime;
            setRegistrationState({ ...registrationState, proofInfo: proofInfo });
        }
    };
    const [isNextOrContinue, isPreviousOrBack] = useButtonText();
    const checkUserAgeError = () => {
        let errorFound = false;
        const values = getValues();
        const minimumMemberAge = 18;
        try {
            const accountDOBinDateFormate = new Date(`${values["birthDay"]} ${values["birthMonth"]} ${values["birthYear"]}`);
            const age = common.calculate_age(accountDOBinDateFormate);
            const todaysDate = new Date();

            if (age < minimumMemberAge) {
                setIdfMinimumAgeError(true);
                errorFound = true;
            } else {
                setIdfMinimumAgeError(() => false);
            }

            if (todaysDate < accountDOBinDateFormate) {
                setIdfFutureDateAgeError(() => true);
                errorFound = true;
            } else {
                setIdfFutureDateAgeError(() => false);
            }
        } catch {
            setIdfFutureDateAgeError(() => false);
            setIdfMinimumAgeError(() => false);
        }

        return errorFound;
    };
    let price: any;
    if (LookupType == "SSSOFFER" && displayData["billingOptions"] && displayData["billingOptions"].cartPrice) {
        price = registrationState.PaymentMode.SubscriptionType
            ? registrationState.PaymentMode.SubscriptionType === "annual"
                ? displayData["packageLookup"].packagDetails[0].yearlySubscriptionPrice
                : displayData["packageLookup"].packagDetails[0].monthlySubscriptionPrice
            : displayData["billingOptions"]?.cartPrice?.discountedPackagePrice;
    } else {
        price =
            registrationState.PaymentMode && registrationState.PaymentMode.SubscriptionType == "annual"
                ? displayData?.billingOptions?.cartPrice?.annualPrice
                : displayData?.billingOptions?.cartPrice?.monthlyPrice;
    }
    useEffect(() => {
        window.scrollTo(0, 0);
        sendRequest("GET", "web/DeviceRisk/GetDeviceActivationStatus").then((deviceVerificationResponse: any) => {
            setDeviceVerificationStatus(deviceVerificationResponse);
            sessionStorage.setItem('activateDeviceVerificationFlag', deviceVerificationResponse);
        });
        if (subscriberDetails && subscriberDetails["isAutoEnrollUser"]) {
            displayData["displayLast4SSN"] = false;
            displayData["displayFullSSN"] = false;
        }
        const selectElement = document.getElementsByClassName("PhoneInputCountrySelect");
        if (selectElement && selectElement.length > 0) {
            for (const el of selectElement) {
                if (el.tagName.toLowerCase() === "select") {
                    el.setAttribute("aria-required", "true");
                }
            }
        }
    }, []);

    const nextRegistrationStep = (personalInfo, country, dob) => {
        if (!!personalInfo.CompanyDomain) {
            services.validateDomain({ domainName: personalInfo.CompanyDomain }).then((data) => {
                if (data.isDomainBlackListed) {
                    setError("CompanyDomain", { type: "domainBlacklisted" });
                    return;
                }
                delete personalInfo["country"];
                setRegistrationState({
                    ...registrationState,
                    personalInfo: {
                        ...personalInfo,
                        ...dob,
                    },
                    addressInfo: { ...registrationState.addressInfo, country: country },
                });
                setLoading(false);
                setForm(false);
            });
        } else {
            delete personalInfo["country"];
            setRegistrationState({
                ...registrationState,
                personalInfo: {
                    ...personalInfo,
                    ...dob,
                },
                addressInfo: { ...registrationState.addressInfo, country: country },
            });
            setLoading(false);
            setForm(false);
        }
    }

    const onSubmit = (personalInfo: any) => {
        // const ssn = watch('check-ssn-3-digit') + watch('check-ssn-2-digit') + watch('check-ssn-4-digit');
        // const confirmSSN = watch('confirm-ssn-3-digit') + watch('confirm-ssn-2-digit') + watch('confirm-ssn-4-digit');
        // if (ssn !== confirmSSN && displayData['displayFullSSN'] && (isIDFPartner ? watch('country') === 'US' : true)) {
        //     setError('confirm-ssn-4-digit', {
        //         type: "validate"
        //     });
        //     return;
        // } else {

        //     if (displayData['displayFullSSN']) {
        //         personalInfo['securityNumber'] = ssn;
        //         personalInfo['confirmSecurityNumber'] = confirmSSN;

        //         delete personalInfo["check-ssn-3-digit"];
        //         delete personalInfo["check-ssn-2-digit"];
        //         delete personalInfo["check-ssn-4-digit"];
        //         delete personalInfo["confirm-ssn-3-digit"];
        //         delete personalInfo["confirm-ssn-2-digit"];
        //         delete personalInfo["confirm-ssn-4-digit"];
        //     }
        // }
        if (checkUserAgeError()) return;
        if (idfMinimumAgeError || idfFutureDateAgeError) return;
        setLoading(true);
        let country = "";
        if (personalInfo && !personalInfo.country) {
            country = "US";
        } else {
            country = personalInfo.country;
        }
        let dob = {};
        if (getValues("birthDay") && getValues("birthMonth") && getValues("birthYear")) {
            dob = {
                birthDay: getValues("birthDay"),
                birthMonth: getValues("birthMonth"),
                birthYear: getValues("birthYear"),
            };
        }
        sendRequest("POST", "web/Registration/validate-email", { email: personalInfo.email })
            .then((res: any): any => {
                if (res["isSuccess"]) {
                    if (res.isEmailExists) {
                        setLoading(false);
                        setError("email", {
                            type: "isEmailExist",
                        });
                        return;
                    }
                    if (deviceVerificationStatus) {
                        const blackBoxKey = send_bb();
                        const checkDeviceRiskRequestBody = {
                            blackbox: blackBoxKey,
                            email: personalInfo["email"],
                            partnerDisplayName: partnerDisplayName,
                            country: country,
                            source: "web",
                            type: "registration",
                            registrastionType: LookupType
                        }
                        sendRequest("POST", "web/DeviceRisk/CheckDeviceRisk", checkDeviceRiskRequestBody).then((deviceRiskData: any) => {
                            if (deviceRiskData["hasError"]) {
                                window.addToDataLayer({ event: "DEVICE_VERIFICATION_API_FAILURE" });
                            } else {
                                window.addToDataLayer({ event: "DEVICE_VERIFICATION_API_SUCCESS" });
                            }
                            if (deviceRiskData.result && deviceRiskData.result.toLowerCase() === 'd') {
                                window.addToDataLayer({ event: "DEVICE_VERIFICATION_DENY_RESULT" });
                                setShowDeviceVerificationError(true);
                                setLoading(false);
                            } else {
                                if (deviceRiskData.result) {
                                    if (deviceRiskData.result.toLowerCase() === 'r') {
                                        window.addToDataLayer({ event: "DEVICE_VERIFICATION_REVIEW_RESULT" });
                                    } else if (deviceRiskData.result.toLowerCase() === 'a') {
                                        window.addToDataLayer({ event: "DEVICE_VERIFICATION_ALLOW_RESULT" });
                                    }
                                }

                                window.addToDataLayer({ event: "Next Button PersonalInformation Click" });
                                nextRegistrationStep(personalInfo, country, dob);
                            }
                        }).catch((error: Error): any => {
                            window.addToDataLayer({ event: "DEVICE_VERIFICATION_API_FAILURE" });
                            window.addToDataLayer({ event: "Next Button PersonalInformation Click" });
                            nextRegistrationStep(personalInfo, country, dob);
                        });
                    } else {
                        window.addToDataLayer({ event: "DEVICE_VERIFICATION_DEACTIVATED" });
                        window.addToDataLayer({ event: "Next Button PersonalInformation Click" });
                        nextRegistrationStep(personalInfo, country, dob);
                    }
                    return;
                }
                if (res && res.status) {
                    switch (res.status) {
                        case "INTERNAL_ERROR":
                            history.push({
                                pathname: "/register/error",
                                state: {
                                    fromRegistration: true,
                                },
                            });
                            break;
                        default:
                            history.push({
                                pathname: "/register/error",
                                state: {
                                    fromRegistration: true,
                                },
                            });
                            break;
                    }
                } else {
                    history.push({
                        pathname: "/register/error",
                        state: {
                            fromRegistration: true,
                        },
                    });
                }
            })
            .catch((error: Error): any => {
                setLoading(false);
            });
    };

    const isIDFUser = () => {
        if (subscriberDetails && subscriberDetails["isIDFUser"]) {
            return true;
        }
        return false;
    };

    const isTUUser = () => {
        if (subscriberDetails && subscriberDetails["istuUser"]) {
            return true;
        }
        return false;
    };

    const isAutoEnrollUser = () => {
        if (subscriberDetails && subscriberDetails["isAutoEnrollUser"]) {
            return true;
        }
        return false;
    };

    const getDefaultEmailValue = () => {
        let email = Object.keys(registrationState.personalInfo).length !== 0 ? registrationState.personalInfo.email : userData && userData.email;
        if (!email && (isIDFUser() || (isAutoEnrollUser() && isTUUser()) || isTypeSSOProvisional)) {
            if (subscriberDetails && subscriberDetails["email"]) {
                email = subscriberDetails["email"];
            }
        }

        return email;
    };

    const userSelectedBirthDateMonthValue =
        subscriberDetails && subscriberDetails["dateOfBirth"] ? moment(subscriberDetails["dateOfBirth"]).format("MMM").toString() : "";
    const userSelectedBirthDateDayValue =
        subscriberDetails && subscriberDetails["dateOfBirth"] ? moment(subscriberDetails["dateOfBirth"]).format("DD").toString() : "";
    const userSelectedBirthDateYearValue =
        subscriberDetails && subscriberDetails["dateOfBirth"] ? moment(subscriberDetails["dateOfBirth"]).format("YYYY").toString() : "";

    useEffect(() => {
        if (subscriberDetails && subscriberDetails["dateOfBirth"] && maxAgeLimit && minAgeLimit) {
            setValue("birthDay", userSelectedBirthDateDayValue);
            setValue("birthMonth", userSelectedBirthDateMonthValue);
            setValue("birthYear", userSelectedBirthDateYearValue);
        }
    }, [subscriberDetails]);
    const dobDay = () => {
        return registrationState?.personalInfo?.birthDay || 1;
    };
    const dobMonth = () => {
        return registrationState?.personalInfo?.birthMonth || 0;
    };

    const dobYear = () => {
        return registrationState?.personalInfo?.birthYear || 2;
    };

    const getDefaultFirstName = () => {
        let firstName = Object.keys(registrationState.personalInfo).length !== 0 ? registrationState.personalInfo.FirstName : userData && userData.firstName;
        if (!firstName && (isIDFUser() || (isAutoEnrollUser() && isTUUser()) || isTypeSSOProvisional)) {
            if (subscriberDetails && subscriberDetails["firstName"]) {
                firstName = subscriberDetails["firstName"];
            }
        }

        return firstName;
    };
    const getDefaultBusinessName = () => {
        let businessName =
            Object.keys(registrationState.personalInfo).length !== 0 ? registrationState.personalInfo.BusinessName : userData && userData.BusinessName;
        if (!businessName && (isIDFUser() || (isAutoEnrollUser() && isTUUser()))) {
            if (subscriberDetails && subscriberDetails["BusinessName"]) {
                businessName = subscriberDetails["BusinessName"];
            }
        }

        return businessName;
    };
    const getDefaultCompanyDomain = () => {
        let companyDomain =
            Object.keys(registrationState.personalInfo).length !== 0 ? registrationState.personalInfo.CompanyDomain : userData && userData.CompanyDomain;
        if (!companyDomain && isAutoEnrollUser()) {
            if (subscriberDetails && (subscriberDetails["CompanyDomain"] || subscriberDetails["domain"])) {
                companyDomain = !!subscriberDetails["CompanyDomain"] ? subscriberDetails["CompanyDomain"] : subscriberDetails["domain"];
            }
        }

        return companyDomain;
    };
    const getDefaultNumberOfEmployees = () => {
        let numberOfEmp =
            Object.keys(registrationState.personalInfo).length !== 0 ? registrationState.personalInfo.numberOfEmployees : userData && userData.numberOfEmployees;
        if (!numberOfEmp && isAutoEnrollUser()) {
            if (subscriberDetails && subscriberDetails["noOfEmployees"]) {
                numberOfEmp = subscriberDetails["noOfEmployees"];
            }
        }

        return numberOfEmp;
    };
    const getDefaultLastName = () => {
        let lastName = Object.keys(registrationState.personalInfo).length !== 0 ? registrationState.personalInfo.LastName : userData && userData.lastname;
        if (!lastName && (isIDFUser() || (isAutoEnrollUser() && isTUUser()) || isTypeSSOProvisional)) {
            if (subscriberDetails && subscriberDetails["lastName"]) {
                lastName = subscriberDetails["lastName"];
            }
        }

        return lastName;
    };

    const getDefaultTelephone = () => {
        const { countryList } = getCountries;
        const countryInfo: any = countryList.find((c: any) => c.countryCode === defaultCountryCode);
        let telephone =
            Object.keys(registrationState.personalInfo).length !== 0
                ? registrationState.personalInfo.phoneNumber
                : userData && userData.phoneNumber
                    ? `+${countryInfo.countryCallingCode}${userData.phoneNumber}`
                    : "";
        if (!telephone && ((isAutoEnrollUser() && isTUUser()) || isTypeSSOProvisional)) {
            if (subscriberDetails && subscriberDetails["telephone"]) {
                if (subscriberDetails["telephone"].includes("+")) {
                    telephone = subscriberDetails["telephone"];
                } else {
                    // telephone = `+${countryInfo.countryCallingCode}${subscriberDetails["telephone"]}`;
                    telephone = subscriberDetails["telephone"];
                }
            }
        }

        return telephone;
    };

    const getCountryInfo = () => {
        let currentCountry = accountInfo && accountInfo.country ? accountInfo.country : "";
        let isCountry = watch("country") && (watch("country").includes("US") || watch("country").includes("CA"));
        if ((currentCountry.includes("US") || currentCountry.includes("CA")) && isCountry) {
            return false;
        } else if (!supportInternational || isCountry) {
            return false;
        } else {
            return true;
        }
    };

    const resetPhoneOnChange = () => {
        setValue("phoneNumber", "");
        setRegistrationState({ ...registrationState, personalInfo: { ...registrationState.personalInfo, phoneNumber: "" } });
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            disableFlag();
        }, 500);
    };

    const setPrevious = () => {
        manage(updateState(FirstTermsStates, displayData.billingRequired, 1));
    };

    const isOTPAllowed = () => {
        return watch("country") === "US" && hasCreditService && hasTUProvider && !isExperianUser;
    };

    function onTextBoxChangeHandler(event: React.ChangeEvent<HTMLInputElement>) {
        let targetName = event.target.name;
        let targetValue = event.target.value;

        if (errors["confirm-ssn-4-digit"] && errors["confirm-ssn-4-digit"].type === "validate") {
            clearErrors("confirm-ssn-4-digit");
        }

        switch (targetName) {
            case "check-ssn-3-digit":
                if (targetValue.length > 2) {
                    document.getElementById("check-ssn-2-digit")?.focus();
                }
                break;
            case "check-ssn-2-digit":
                if (targetValue.length > 1) {
                    document.getElementById("check-ssn-4-digit")?.focus();
                }
                break;
            case "check-ssn-4-digit":
                if (targetValue.length > 3) {
                    document.getElementById("confirm-ssn-3-digit")?.focus();
                }
                break;
            case "confirm-ssn-3-digit":
                if (targetValue.length > 2) {
                    document.getElementById("confirm-ssn-2-digit")?.focus();
                }
                break;
            case "confirm-ssn-2-digit":
                if (targetValue.length > 1) {
                    document.getElementById("confirm-ssn-4-digit")?.focus();
                }
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        disableFlag();
    }, [accountInfo]);

    useEffect(() => {
        if (supportInternational === true) {
            setValue("country", defaultCountryCode);
        }
    }, [defaultCountryCode]);

    const getCountryCode = () => {
        let countryCode = "US";
        if (supportInternational === true) {
            countryCode = defaultCountryCode
                ? defaultCountryCode
                : Object.keys(registrationState.addressInfo).length !== 0
                    ? registrationState.addressInfo.country
                    : "";
        }
        return countryCode;
    };

    const disableFlag = () => {
        setTimeout(() => {
            const el = document.getElementsByClassName("PhoneInputCountry");
            if (el && el.length > 0) {
                try {
                    const childs = el[0].children;
                    if (childs[0].nodeName === "SELECT") {
                        const selectEl = childs[0] as HTMLSelectElement;
                        selectEl.disabled = true;
                    }
                } catch { }
            }
        }, 500);
    };

    const send_bb = () => {
        var blackbox = "";
        try {
            blackbox = window.IGLOO.getBlackbox().blackbox;
        } catch (e) { }
        return blackbox;
    };

    const isDobDisabled = maxAgeLimit && minAgeLimit;
    const dateFields = [
        <div className="col-xs-4 col-no-gutter">
            <div className={`form-row row ${(errors["birthYear"] || errors["birthDay"] || errors["birthMonth"]) && "status-error"}`}>
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-dob-day">Date of Birth Day</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register({ required: true })}
                        name="birthDay"
                        className="inputbox"
                        id="label-dob-day"
                        defaultValue={dobDay()}
                        onChange={checkUserAgeError}
                        disabled={isDobDisabled}
                        aria-required="true"
                    >
                        <option value="">{tLang("registration.personalInfo1Widget.placeholder.day")}</option>
                        {Array(31)
                            .fill(null)
                            .map((value, index) => {
                                return (
                                    <option key={index + 1} value={index < 9 ? "0" + (index + 1) : index + 1}>
                                        {index < 9 ? "0" + (index + 1) : index + 1}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className={`form-row row ${(errors["birthYear"] || errors["birthDay"] || errors["birthMonth"]) && "status-error"}`}>
                {/*<div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-dob-month" >Date of Birth Month</label>
                </div>*/}
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register({ required: true })}
                        name="birthMonth"
                        className="inputbox"
                        id="label-dob-month"
                        defaultValue={dobMonth()}
                        onChange={checkUserAgeError}
                        disabled={isDobDisabled}
                        aria-required="true"
                    >
                        <option value="">{tLang("registration.personalInfo1Widget.placeholder.month")}</option>
                        {months.map((month) => {
                            return (
                                <option key={month} value={month}>
                                    {month}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className={`form-row row ${(errors["birthYear"] || errors["birthDay"] || errors["birthMonth"]) && "status-error"}`}>
                <div className="form-label sr-only col-xs-12 col-no-gutter ">
                    <label htmlFor="label-dob-year">Date of Birth Year</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register({ required: true })}
                        name="birthYear"
                        className="inputbox"
                        id="label-dob-year"
                        defaultValue={dobYear()}
                        onChange={checkUserAgeError}
                        disabled={isDobDisabled}
                        aria-required="true"
                    >
                        <option value="">{tLang("registration.personalInfo1Widget.placeholder.year")}</option>
                        {Array(115)
                            .fill(null)
                            .map((value, index) => {
                                const optionValue = new Date().getFullYear() - index;
                                return (
                                    <option key={optionValue} value={optionValue}>
                                        {optionValue}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
    ];

    return (
        <>
            {/* page content */}
            {showDeviceVerificationError ?
                <DeviceVerificationError /> :
                <div className="row" id="content">
                    <div className="col-xs">
                        <div className="box box-has-shadow offset-padding">
                            <div className="box-header">
                                <div className="row box-title-container">
                                    {showLogoOnRegistrationScreens && (
                                        <div className="col-xs-12 col-sm-0 hide-sm-up text-align-center">
                                            <LogoContainer internalPage={false} showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                                        </div>
                                    )}
                                    <div className={showLogoOnRegistrationScreens ? "col-xs-12 col-sm-6" : ""}>
                                        <div className="box-title-icon" aria-hidden="true">
                                            <RenderIcons iconName={"user"} />
                                        </div>
                                        <div className="box-title-text">
                                            <h2 className="box-title">{tLang("registration.personalInfo1Widget.title")}</h2>
                                        </div>
                                    </div>
                                    {showLogoOnRegistrationScreens && (
                                        <div className="col-xs-0 col-sm-6 row flex-end">
                                            <LogoContainer internalPage={false} className="hide-mobile" showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className={loading ? "box-content loading" : "box-content"}>
                                <form onSubmit={handleSubmit(onSubmit)} id="register-personal-info-1">
                                    <div className="row between-sm">
                                        <div className="col-xs-12 col-sm-7 col-no-gutter">
                                            <p>{tLang("registration.personalInfo1Widget.message")}</p>
                                            <div className="margin-bottom-l"></div>

                                        <div role="grid" className="data-grid">
                                            <div role="row" className="data-row row">
                                                <div
                                                    role="gridcell"
                                                    className={`col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-5" : "col-sm-4"} col-no-gutter`}
                                                >
                                                    <div className="data-label" id="label-primary-email">
                                                        <label htmlFor="label-email">
                                                            {tLang("registration.personalInfo1Widget.label.primaryEmail")}
                                                            <span className="required" title="Mandatory">
                                                                {" "}
                                                                *
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div
                                                    role="gridcell"
                                                    className={`col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-7" : "col-sm-8"} col-no-gutter`}
                                                >
                                                    <div className="data-value">
                                                        {isTypeSSOProvisional && getDefaultEmailValue() && !allowSSORegistrationFlow && <span>{getDefaultEmailValue()}</span>}
                                                        <input
                                                            type="text"
                                                            className={
                                                                isTypeSSOProvisional && getDefaultEmailValue() && !allowSSORegistrationFlow  ? "inputbox ant-picker-dropdown-hidden" : "inputbox"
                                                            }
                                                            id="label-email"
                                                            placeholder={tLang("registration.personalInfo1Widget.placeholder.primaryEmail")}
                                                            name="email"
                                                            readOnly={isIDFUser() && LookupType !== "IDFBREACH"}
                                                            defaultValue={getDefaultEmailValue()}
                                                            ref={register({
                                                                required: true,
                                                                pattern: PATTERNS.EMAIL.pattern,
                                                            })}
                                                            aria-required="true"
                                                        />
                                                        {!!errors["email"] && errors["email"].type === "required" && (
                                                            <span role="alert" className="form-error">
                                                                {tLang("registration.personalInfo1Widget.validationMessage.primaryEmail.required")}
                                                            </span>
                                                        )}
                                                        {!!errors["email"] && errors["email"].type === "pattern" && (
                                                            <span role="alert" className="form-error">
                                                                {tLang("registration.personalInfo1Widget.validationMessage.primaryEmail.pattern")}
                                                            </span>
                                                        )}
                                                        {!!errors["email"] && errors["email"].type === "isEmailExist" && (
                                                            <span role="alert" className="form-error">
                                                                {tLang("registration.personalInfo1Widget.validationMessage.primaryEmail.duplicate")}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                            <fieldset className="form-row inline">
                                                <div className="row">
                                                    <div className={`col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-5" : "col-sm-4"} col-no-gutter`}>
                                                        <legend className="legend-label">
                                                            {" "}
                                                            <label htmlFor="label-first-name">
                                                                {tLang("registration.personalInfo1Widget.label.fullName")}
                                                                <span className="required" title="Mandatory">
                                                                    {" "}
                                                                    *
                                                                </span>
                                                            </label>
                                                        </legend>
                                                    </div>
                                                    <div className={`col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-7" : "col-sm-8"} col-no-gutter`}>
                                                        <div className="row">
                                                            <div className="col-xs-12 col-no-gutter">
                                                                <div className={`form-row row ${errors["FirstName"] && "status-error"}`}>
                                                                    <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                        <label htmlFor="label-first-name-1">First Name</label>
                                                                    </div>
                                                                    <div className="form-input col-xs-12 col-no-gutter">
                                                                        <input
                                                                            type="text"
                                                                            name="FirstName"
                                                                            className="inputbox"
                                                                            id="label-first-name"
                                                                            placeholder={tLang("registration.personalInfo1Widget.placeholder.firstName")}
                                                                            readOnly={isTUUser() && isAutoEnrollUser()}
                                                                            defaultValue={getDefaultFirstName()}
                                                                            ref={register({ pattern: PATTERNS.FIRSTNAME.pattern, required: true })}
                                                                            aria-required="true"
                                                                        />
                                                                        {!!errors["FirstName"] && errors["FirstName"].type === "pattern" && (
                                                                            <span role="alert" className="form-error">
                                                                                {tLang("registration.personalInfo1Widget.validationMessage.firstName.pattern")}
                                                                            </span>
                                                                        )}
                                                                        {!!errors["FirstName"] && errors["FirstName"].type === "required" && (
                                                                            <span role="alert" className="form-error">
                                                                                {tLang("registration.personalInfo1Widget.validationMessage.firstName.required")}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-xs-12 col-no-gutter">
                                                                <div className={`form-row row ${errors["LastName"] && "status-error"}`}>
                                                                    <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                        <label htmlFor="label-last-name">Last Name</label>
                                                                    </div>
                                                                    <div className="form-input col-xs-12 col-no-gutter">
                                                                        <input
                                                                            type="text"
                                                                            name="LastName"
                                                                            className="inputbox"
                                                                            id="label-last-name"
                                                                            placeholder={tLang("registration.personalInfo1Widget.placeholder.lastName")}
                                                                            readOnly={isTUUser() && isAutoEnrollUser()}
                                                                            defaultValue={getDefaultLastName()}
                                                                            ref={register({ pattern: PATTERNS.LASTNAME.pattern, required: true })}
                                                                            aria-required="true"
                                                                        />
                                                                        {!!errors["LastName"] && errors["LastName"].type === "pattern" && (
                                                                            <span role="alert" className="form-error">
                                                                                {tLang("registration.personalInfo1Widget.validationMessage.lastName.pattern")}
                                                                            </span>
                                                                        )}
                                                                        {!!errors["LastName"] && errors["LastName"].type === "required" && (
                                                                            <span role="alert" className="form-error">
                                                                                {tLang("registration.personalInfo1Widget.validationMessage.lastName.required")}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>

                                            {/*DOB*/}
                                            {displayData["displayDOB"] && hasTUProvider && (
                                                <fieldset className={idfFutureDateAgeError || idfMinimumAgeError ? "form-row inline status-error" : "form-row inline"}>
                                                    <div className="row">
                                                        <div className={`col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-5" : "col-sm-4"} col-no-gutter`}>
                                                            <legend className="legend-label">
                                                                <label htmlFor="label-dob-month">
                                                                    {tLang("registration.personalInfo1Widget.placeholder.dateOfBirth")}
                                                                    <span className="required" title="Mandatory">
                                                                        {" "}
                                                                        *
                                                                    </span>
                                                                </label>
                                                            </legend>
                                                        </div>

                                                        <div className={`col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-7" : "col-sm-8"} col-no-gutter`}>
                                                            <div className="row ">
                                                                {getCountryCode() === "US" ? (
                                                                    <>
                                                                        {dateFields[1]} {dateFields[0]} {dateFields[2]}{" "}
                                                                    </>
                                                                ) : getCountryCode() === "CA" || getCountryCode() === "TW" ? (
                                                                    <>
                                                                        {dateFields[2]} {dateFields[1]} {dateFields[0]}{" "}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {dateFields[0]} {dateFields[1]} {dateFields[2]}
                                                                    </>
                                                                )}

                                                                {idfFutureDateAgeError && <span className="form-error">{tLang("registration.personalInfo1Widget.validationMessage.dateOfBirth.futureAgeError")}</span>}
                                                                {idfMinimumAgeError && <span className="form-error">{tLang("registration.personalInfo1Widget.validationMessage.dateOfBirth.minimumAgeError")}</span>}
                                                                {(errors["birthYear"] || errors["birthDay"] || errors["birthMonth"]) &&
                                                                    ((errors["birthYear"] && errors["birthYear"].type === "required") ||
                                                                        (errors["birthDay"] && errors["birthDay"].type === "required") ||
                                                                        (errors["birthMonth"] && errors["birthMonth"].type === "required")) && (
                                                                        <span role="alert" className="form-error">
                                                                            {tLang("registration.personalInfo1Widget.validationMessage.dateOfBirth.required")}
                                                                        </span>
                                                                    )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            )}

                                            {isBusinessUser && (
                                                <div className="form-row inline">
                                                    <div className="row">
                                                        <div className={`col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-5" : "col-sm-4"} col-no-gutter`}>
                                                            <label className="legend-label" htmlFor="label-business-name">
                                                                {tLang("registration.personalInfo1Widget.businessUser.label.businessName")}
                                                                <span className="required" title="Mandatory">
                                                                    {" "}
                                                                    *
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div className={`col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-7" : "col-sm-8"} col-no-gutter`}>
                                                            <div className="row">
                                                                <div className="col-xs-12 col-no-gutter">
                                                                    <div className={`form-row row ${errors["BusinessName"] && "status-error"}`}>
                                                                        <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                            <label htmlFor="label-business-name-1">
                                                                                {tLang("registration.personalInfo1Widget.businessUser.label.businessName")}
                                                                                <span className="required" title="Mandatory">
                                                                                    {" "}
                                                                                    *
                                                                                </span>
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                                            <input
                                                                                type="text"
                                                                                name="BusinessName"
                                                                                className="inputbox"
                                                                                id="label-business-name"
                                                                                placeholder={tLang(
                                                                                    "registration.personalInfo1Widget.businessUser.placeholder.businessName"
                                                                                )}
                                                                                defaultValue={getDefaultBusinessName()}
                                                                                ref={register({ pattern: PATTERNS.BUSINESSNAME.pattern, required: true })}
                                                                                aria-required="true"
                                                                            />

                                                                            {!!errors["BusinessName"] && errors["BusinessName"].type === "pattern" && (
                                                                                <span role="alert" className="form-error">
                                                                                    {tLang(
                                                                                        "registration.personalInfo1Widget.businessUser.validation.businessName.pattern"
                                                                                    )}
                                                                                </span>
                                                                            )}
                                                                            {!!errors["BusinessName"] && errors["BusinessName"].type === "required" && (
                                                                                <span role="alert" className="form-error">
                                                                                    {tLang(
                                                                                        "registration.personalInfo1Widget.businessUser.validation.businessName.required"
                                                                                    )}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {displayData["displayNoOfEmployees"] && (
                                                <div className="form-row inline row">
                                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                        <label htmlFor="plan-employees">
                                                            {tLang("registration.personalInfo1Widget.businessUser.label.numberOfEmployees")}
                                                        </label>
                                                    </div>
                                                    <div className="form-input col-xs-8 col-no-gutter">
                                                        <select
                                                            className="inputbox"
                                                            id="plan-employees"
                                                            name="numberOfEmployees"
                                                            ref={register}
                                                            defaultValue={getDefaultNumberOfEmployees()}
                                                        >
                                                            {numberOfEmployees.map((range: any, index: number) => (
                                                                <option key={`range-${index}`} value={range}>
                                                                    {range}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            )}
                                            {isDisplayDomain && (
                                                <div className="form-row inline">
                                                    <div className="row">
                                                        <div className={`col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-5" : "col-sm-4"} col-no-gutter`}>
                                                            <label className="legend-label" htmlFor="label-company-domain">
                                                                {tLang("registration.personalInfo1Widget.businessUser.label.companyDomain")}
                                                            </label>
                                                        </div>
                                                        <div className={`col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-7" : "col-sm-8"} col-no-gutter`}>
                                                            <div className="row">
                                                                <div className="col-xs-12 col-no-gutter">
                                                                    <div className={`form-row row ${errors["CompanyDomain"] && "status-error"}`}>
                                                                        <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                            <label htmlFor="label-company-domain-1">
                                                                                {tLang("registration.personalInfo1Widget.businessUser.label.companyDomain")}
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                                            <input
                                                                                type="text"
                                                                                name="CompanyDomain"
                                                                                className="inputbox"
                                                                                id="label-company-domain"
                                                                                placeholder={tLang(
                                                                                    "registration.personalInfo1Widget.businessUser.placeholder.companyDomain"
                                                                                )}
                                                                                defaultValue={getDefaultCompanyDomain()}
                                                                                ref={register({
                                                                                    pattern: PATTERNS.COMPANYDOMAIN.pattern,
                                                                                    validate: (value) => !value.split(".")[0].includes("www"),
                                                                                })}
                                                                            />
                                                                            {!!errors["CompanyDomain"] &&
                                                                                (errors["CompanyDomain"].type === "pattern" ||
                                                                                    errors["CompanyDomain"].type === "validate") && (
                                                                                    <span role="alert" className="form-error">
                                                                                        {tLang(
                                                                                            "registration.personalInfo1Widget.businessUser.validation.companyDomain.pattern"
                                                                                        )}
                                                                                    </span>
                                                                                )}

                                                                            {!!errors["CompanyDomain"] && errors["CompanyDomain"].type === "domainBlacklisted" && (
                                                                                <span role="alert" className="form-error">
                                                                                    We are unable to monitor public email domains. Please enter a custom company domain,
                                                                                    if you have one.
                                                                                </span>
                                                                            )}

                                                                            <p>{tLang("registration.personalInfo1Widget.businessUser.companyDomainInstruction")}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <fieldset className="form-row inline">
                                                <div className="row">
                                                    <div className={`form-row inline row ${errors["country"] && "status-error"}`}>
                                                        <div
                                                            className={`form-label col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-5" : "col-sm-4"} col-no-gutter`}
                                                        >
                                                            <legend className="legend-label">
                                                                {" "}
                                                                <label htmlFor="label-address-country">
                                                                    {tLang("registration.personalInfo1Widget.label.country")}
                                                                    <span className="required" title="Mandatory">
                                                                        {" "}
                                                                        *
                                                                    </span>
                                                                </label>
                                                            </legend>
                                                        </div>
                                                        <div
                                                            className={`form-input col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-7" : "col-sm-8"} col-no-gutter`}
                                                        >
                                                            {supportInternational ? (
                                                                <select
                                                                    className="inputbox"
                                                                    id="label-address-country"
                                                                    onChange={() => resetPhoneOnChange()}
                                                                    defaultValue={
                                                                        defaultCountryCode
                                                                            ? defaultCountryCode
                                                                            : Object.keys(registrationState.addressInfo).length !== 0
                                                                                ? registrationState.addressInfo.country
                                                                                : ""
                                                                    }
                                                                    name="country"
                                                                    ref={register({ required: true, validate: (value) => value !== "---" })}
                                                                    aria-required="true"
                                                                >
                                                                    {getCountries.countryList.length &&
                                                                        getCountries.countryList.map((val: any) => (
                                                                            <option key={val.name} value={val.countryCode}>
                                                                                {val.name}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            ) : (
                                                                <select
                                                                    name="country"
                                                                    ref={register({ required: true })}
                                                                    disabled={true}
                                                                    defaultValue={"US"}
                                                                    className="inputbox"
                                                                    id="label-address-country"
                                                                    aria-required="true"
                                                                >
                                                                    <option value={"US"}>United States of America</option>
                                                                </select>
                                                            )}
                                                            {errors["country"] && errors["country"].type === "validate" && (
                                                                <span role="alert" className="form-error">
                                                                    Country is required.
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>

                                            <fieldset className="form-row inline">
                                                <div className="row">
                                                    <div className={`col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-5" : "col-sm-4"} col-no-gutter`}>
                                                        <legend className="legend-label">
                                                            <label htmlFor="label-phone-number">
                                                                {tLang("registration.personalInfo1Widget.label.mobile")}
                                                                <span className="required" title="Mandatory">
                                                                    {" "}
                                                                    *
                                                                </span>
                                                            </label>
                                                        </legend>
                                                    </div>

                                                    <div className={`col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-7" : "col-sm-8"} col-no-gutter`}>
                                                        <div className="row ">
                                                            <div className="col-xs-12 col-no-gutter">
                                                                <div
                                                                    className={`form-row row ${errors["phoneNumber"] && "status-error"} ${errors["phoneNumber"] && watch("phoneNumber") && !parsePhoneNumber(watch("phoneNumber"))
                                                                        ? "country-error"
                                                                        : ""
                                                                        }`}
                                                                >
                                                                    {/*<div className="form-label sr-only col-xs-12  col-no-gutter">
                                                                    <label htmlFor="label-phone-number">Number </label>
                                                                </div>*/}
                                                                    {!loading && (
                                                                        <div className="form-input col-xs-12  col-no-gutter">
                                                                            <Controller
                                                                                name={`phoneNumber`}
                                                                                control={control}
                                                                                defaultValue={getDefaultTelephone()}
                                                                                className="inputbox"
                                                                                rules={{
                                                                                    required: true,
                                                                                    validate: (value: any) =>
                                                                                        value
                                                                                            ? isValidPhoneNo(watch("country") ? watch("country") : "US", value)
                                                                                            : false,
                                                                                }}
                                                                                aria-required="true"
                                                                                render={({ onChange, value }) => (
                                                                                    <PhoneInput
                                                                                        className="inputbox"
                                                                                        value={value}
                                                                                        onChange={onChange}
                                                                                        international={false}
                                                                                        addInternationalOption={false}
                                                                                        defaultCountry={watch("country") ? watch("country") : "US"}
                                                                                        countries={[watch("country") ? watch("country") : "US"]}
                                                                                        id="label-phone-number"
                                                                                        placeholder={tLang("registration.personalInfo1Widget.label.mobile")}
                                                                                        maxLength={15}
                                                                                        minLength={10}
                                                                                        aria-required="true"
                                                                                    />
                                                                                )}
                                                                            />
                                                                            {!!errors["phoneNumber"] && errors["phoneNumber"].type === "required" && (
                                                                                <span role="alert" className="form-error">
                                                                                    {tLang("registration.personalInfo1Widget.validationMessage.phone.requiredMobile")}
                                                                                </span>
                                                                            )}
                                                                            {!!errors["phoneNumber"] && errors["phoneNumber"].type === "validate" && (
                                                                                <span role="alert" className="form-error">
                                                                                    {tLang("registration.personalInfo1Widget.validationMessage.phone.validateMobile")}
                                                                                </span>
                                                                            )}
                                                                            {!!errors["phoneNumber"] &&
                                                                                errors["phoneNumber"].type === "minLength" &&
                                                                                (getCountryInfo() ? (
                                                                                    <span role="alert" className="form-error">
                                                                                        {tLang(
                                                                                            "identityVault.monitoredInformation.personalInfoWidget.validationMessage.phoneMinlengthError"
                                                                                        )}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span role="alert" className="form-error">
                                                                                        {tLang(
                                                                                            "registration.personalInfo1Widget.validationMessage.phone.patternMobile"
                                                                                        )}
                                                                                    </span>
                                                                                ))}
                                                                            {!!errors["phoneNumber"] &&
                                                                                errors["phoneNumber"].type === "maxLength" &&
                                                                                (getCountryInfo() ? (
                                                                                    <span role="alert" className="form-error">
                                                                                        {tLang(
                                                                                            "identityVault.monitoredInformation.personalInfoWidget.validationMessage.phoneMaxlengthError"
                                                                                        )}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span role="alert" className="form-error">
                                                                                        {tLang(
                                                                                            "registration.personalInfo1Widget.validationMessage.phone.patternMobile"
                                                                                        )}
                                                                                    </span>
                                                                                ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>

                                            {/* displayData['displayDOB'] && <fieldset className={(idfFutureDateAgeError || idfMinimumAgeError) ? "form-row inline status-error" : "form-row inline"}>
                                            <div className="row">

                                                <div className={`col-xs-12 ${displayData['displayFullSSN'] ? 'col-sm-5' : 'col-sm-4'} col-no-gutter`}>
                                                    <legend className="legend-label">Date of Birth</legend>
                                                </div>

                                                <div className={`col-xs-12 ${displayData['displayFullSSN'] ? 'col-sm-7' : 'col-sm-8'} col-no-gutter`}>
                                                    <div className="row ">

                                                        <div className="col-xs-4 col-no-gutter">
                                                            <div className="form-row row">
                                                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                    <label htmlFor="label-dob-month">Date of Birth Month</label>
                                                                </div>
                                                                <div
                                                                    className="form-input col-xs-12 col-no-gutter padding-right-xs">

                                                                    <select ref={register} name="birthMonth" onChange={checkUserAgeError} defaultValue={userSelectedBirthDateMonthValue ? userSelectedBirthDateMonthValue : months[0]}
                                                                        className="inputbox" id="label-dob-month">
                                                                        {
                                                                            months.map((month) => {
                                                                                return <option key={month} value={month}>{month}
                                                                                </option>
                                                                            })
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-xs-4 col-no-gutter">
                                                            <div className="form-row row">
                                                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                    <label htmlFor="label-dob-day">Date of Birth Day</label>
                                                                </div>
                                                                <div
                                                                    className="form-input col-xs-12 col-no-gutter padding-right-xs">

                                                                    <select ref={register} name="birthDay" onChange={checkUserAgeError} className="inputbox" defaultValue={userSelectedBirthDateDayValue ? userSelectedBirthDateDayValue : "1"}
                                                                        id="label-dob-day">
                                                                        {
                                                                            Array(31).fill(null).map((value, index) => {
                                                                                return <option key={index + 1} value={index + 1}>{index
                                                                                    + 1}</option>
                                                                            })}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-xs-4 col-no-gutter">
                                                            <div className="form-row row">
                                                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                    <label htmlFor="label-dob-year">Date of Birth Year</label>
                                                                </div>
                                                                <div className="form-input col-xs-12 col-no-gutter">
                                                                    <select ref={register} name="birthYear" onChange={checkUserAgeError} className="inputbox" defaultValue={userSelectedBirthDateYearValue ? userSelectedBirthDateYearValue : new Date().getFullYear().toString()}
                                                                        id="label-dob-year">
                                                                        {
                                                                            Array(100).fill(null).map((value, index) => {
                                                                                const optionValue = new Date().getFullYear() - index;
                                                                                return <option key={optionValue} value={optionValue}>
                                                                                    {optionValue}</option>
                                                                            })}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {idfFutureDateAgeError && (
                                                            <span className="form-error">Members cannot be born at future dates.</span>
                                                        )}
                                                        {idfMinimumAgeError && (
                                                            <span className="form-error">Member must be 18 years old or older</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset> */}
                                            {/* (displayData['displayLast4SSN'] || displayData['displayFullSSN']) && (isIDFPartner ? watch('country') === 'US' : true) &&
                                            <div>
                                                <div className={`form-row inline row ${(errors['securityNumber'] || errors['check-ssn-3-digit'] || errors['check-ssn-2-digit'] || errors['check-ssn-4-digit']) && 'status-error'}`}>
                                                    <div className={`form-label col-xs-12 ${displayData['displayFullSSN'] ? 'col-sm-5' : 'col-sm-4'} col-no-gutter`}>
                                                        <legend className="legend-label">{displayData['displayLast4SSN'] ? 'Last 4 digits of SSN' : 'Social Security #'}</legend>
                                                    </div>
                                                    <div className={`form-input col-xs-12 ${displayData['displayFullSSN'] ? 'col-sm-7' : 'col-sm-8'} col-no-gutter`}>
                                                        {!displayData['displayLast4SSN'] ?

                                                            <div className="form-input row">
                                                                <div className="col-xs-4 col-sm-4 col-no-gutter">
                                                                    <input
                                                                        ref={register({ required: true, pattern: /(^(?!0{3})(\d{3})(?!-?0{3})(|-\d{3})?$)/ })}
                                                                        type={'password'}
                                                                        name='check-ssn-3-digit'
                                                                        maxLength={3}
                                                                        className='inputbox'
                                                                        autoComplete='off'
                                                                        onChange={onTextBoxChangeHandler}
                                                                    />
                                                                </div>
                                                                <div className="col-xs-4 col-sm-3 col-gutter-horizontal">
                                                                    <input
                                                                        ref={register({ required: true, pattern: /(^(\d{2})(?!-?0{2})(|-\d{2})?$)/ })}
                                                                        type={'password'}
                                                                        name='check-ssn-2-digit'
                                                                        id='check-ssn-2-digit'
                                                                        maxLength={2}
                                                                        autoComplete='off'
                                                                        className='inputbox'
                                                                        onChange={onTextBoxChangeHandler}
                                                                    />
                                                                </div>
                                                                <div className="col-xs-4 col-sm-5 col-no-gutter">
                                                                    <input
                                                                        ref={register({ required: true, pattern: /(^(?!0{4})(\d{4})(?!-?0{4})(|-\d{4})?$)/ })}
                                                                        type={'password'}
                                                                        name='check-ssn-4-digit'
                                                                        id='check-ssn-4-digit'
                                                                        maxLength={4}
                                                                        autoComplete='off'
                                                                        className='inputbox'
                                                                        onChange={onTextBoxChangeHandler}
                                                                    />
                                                                </div>
                                                            </div>
                                                            :
                                                            <input type="text" className="inputbox" id="label-ssn"
                                                                defaultValue={registrationState.personalInfo && registrationState.personalInfo.securityNumber}
                                                                name="securityNumber" maxLength={4} ref={register({ required: true, pattern: /^(\d{4})|$^[0-9]*$/ })} />

                                                        }
                                                        {errors['securityNumber'] && errors['securityNumber'].type === 'required' &&
                                                            (<span className="form-error">SSN is required.</span>)}
                                                        {errors['securityNumber'] && errors['securityNumber'].type === 'pattern' &&
                                                            (<span className="form-error">Please enter valid SSN.</span>)}
                                                        {({ ...errors['check-ssn-3-digit'] }.type === 'required'
                                                            || { ...errors['check-ssn-2-digit'] }.type === 'required'
                                                            || { ...errors['check-ssn-4-digit'] }.type === 'required') &&
                                                            (<span className="form-error">SSN is required</span>)}

                                                        {({ ...errors['check-ssn-3-digit'] }.type === 'pattern'
                                                            || { ...errors['check-ssn-2-digit'] }.type === 'pattern'
                                                            || { ...errors['check-ssn-4-digit'] }.type === 'pattern') &&
                                                            (<span className="form-error">Please enter valid SSN.</span>)}

                                                    </div>
                                                </div>
                                                <div className={`form-row inline row ${(errors['confirmSecurityNumber'] || errors['confirm-ssn-3-digit'] || errors['confirm-ssn-2-digit'] || errors['confirm-ssn-4-digit']) && 'status-error'}`}>
                                                    <div className={`form-label col-xs-12 ${displayData['displayFullSSN'] ? 'col-sm-5' : 'col-sm-4'} col-no-gutter`}>
                                                        <legend className="legend-label">{!displayData.displayLast4SSN ? 'Confirm Social Security #' : 'Confirm Last 4 digits of SSN'}</legend>
                                                    </div>
                                                    <div className={`form-input col-xs-12 ${displayData['displayFullSSN'] ? 'col-sm-7' : 'col-sm-8'} col-no-gutter`}>

                                                        {!displayData.displayLast4SSN ?
                                                            <div className="form-input row">
                                                                <div className="col-xs-4 col-sm-4 col-no-gutter">
                                                                    <input
                                                                        ref={register({ required: true, pattern: /(^(?!0{3})(\d{3})(?!-?0{3})(|-\d{3})?$)/ })}
                                                                        type={'password'}
                                                                        name='confirm-ssn-3-digit'
                                                                        id='confirm-ssn-3-digit'
                                                                        maxLength={3}
                                                                        className='inputbox'
                                                                        autoComplete='off'
                                                                        onChange={onTextBoxChangeHandler}
                                                                    />
                                                                </div>
                                                                <div className="col-xs-4 col-sm-3 col-gutter-horizontal">
                                                                    <input
                                                                        ref={register({ required: true, pattern: /(^(\d{2})(?!-?0{2})(|-\d{2})?$)/ })}
                                                                        type={'password'}
                                                                        name='confirm-ssn-2-digit'
                                                                        id='confirm-ssn-2-digit'
                                                                        maxLength={2}
                                                                        autoComplete='off'
                                                                        className='inputbox'
                                                                        onChange={onTextBoxChangeHandler}
                                                                    />
                                                                </div>
                                                                <div className="col-xs-4 col-sm-5 col-no-gutter">
                                                                    <input
                                                                        ref={register({ required: true, pattern: /(^(?!0{4})(\d{4})(?!-?0{4})(|-\d{4})?$)/ })}
                                                                        type={'password'}
                                                                        name='confirm-ssn-4-digit'
                                                                        id='confirm-ssn-4-digit'
                                                                        maxLength={4}
                                                                        autoComplete='off'
                                                                        className='inputbox'
                                                                    />
                                                                </div>
                                                            </div>
                                                            :
                                                            <input type="text" className="inputbox" id="label-ssn" name="confirmSecurityNumber" maxLength={4}
                                                                ref={register({
                                                                    required: true, pattern: /^(\d{4})|$^[0-9]*$/,
                                                                    validate: (value) => value === watch('securityNumber') || "Confirm security number do not match."
                                                                })}
                                                                defaultValue={registrationState.personalInfo && registrationState.personalInfo.confirmSecurityNumber}
                                                            />

                                                        }
                                                        {errors['confirmSecurityNumber'] && errors['confirmSecurityNumber'].type === 'validate' &&
                                                            (<span className="form-error">Confirm SSN does not match.</span>)}
                                                        {errors['confirmSecurityNumber'] && errors['confirmSecurityNumber'].type === 'required' &&
                                                            (<span className="form-error">Confirm SSN is required.</span>)}
                                                        {errors['confirmSecurityNumber'] && errors['confirmSecurityNumber'].type === 'pattern' &&
                                                            (<span className="form-error">Please enter valid Confirm SSN.</span>)}

                                                        {({ ...errors['confirm-ssn-3-digit'] }.type === 'required'
                                                            || { ...errors['confirm-ssn-2-digit'] }.type === 'required'
                                                            || { ...errors['confirm-ssn-4-digit'] }.type === 'required') &&
                                                            (<span className="form-error">Confirm SSN is required.</span>)}

                                                        {({ ...errors['confirm-ssn-3-digit'] }.type === 'pattern'
                                                            || { ...errors['confirm-ssn-2-digit'] }.type === 'pattern'
                                                            || { ...errors['confirm-ssn-4-digit'] }.type === 'pattern') &&
                                                            (<span className="form-error">Please enter valid Confirm SSN.</span>)}
                                                        {errors['confirm-ssn-4-digit'] && errors['confirm-ssn-4-digit'].type === 'validate' &&
                                                            (<span className="form-error">Confirm SSN does not match.</span>)}
                                                    </div>
                                                </div>
                                            </div>
                                         */}
                                        {((Gndrll && Gndrll.includes("PSS") && !IsWhiteLabeled) || LookupType == "SSSOFFER" || LookupType == "WALKUP") && (
                                            <>
                                                <div className="margin-bottom-l"></div>
                                                <div className="box-content">
                                                    {isDynamicFooter ? (
                                                        <p>
                                                            {isBusinessUser ? tLang("registration.billing.terms-of-Use.terms-BusinessText") : tLang("registration.billing.terms-of-Use.terms-Text1")}
                                                            <div className="margin-bottom-l"></div>
                                                            {tLang("registration.billing.terms-of-Use.terms-Text2")}{" "}
                                                            {hasSontiqBrand || isIDFPartner ? (
                                                                <a href={defaultTncLink} target="_blank">
                                                                    {getTermsOfUseLinkText()}
                                                                </a>
                                                            ) : (
                                                                <a href={getTermsOfUseURL()} target="_blank">
                                                                    {getTermsOfUseLinkText()}
                                                                </a>
                                                            )}
                                                            {", "}
                                                            <a href={getPrivacyNoticeURL()} target="_blank">
                                                                {getPrivacyNoticeLinkText()}
                                                            </a>
                                                            {" "}
                                                            {tLang("registration.billing.terms-of-Use.terms-Text3")}{" "}
                                                            <a href={personalInformationLink} target="_blank">
                                                                {getPersonalInfoLinkText()}
                                                            </a>
                                                            {"."}
                                                        </p>
                                                    ) : (
                                                        <p>
                                                            {isBusinessUser ? tLang("registration.billing.terms-of-Use.terms-BusinessText") : tLang("registration.billing.terms-of-Use.terms-Text1")}
                                                            <div className="margin-bottom-l"></div>
                                                            {tLang("registration.billing.terms-of-Use.terms-Text2")}{" "}
                                                            {hasSontiqBrand || isIDFPartner ? (
                                                                <a href={defaultTncLink} target="_blank">
                                                                    {getTermsOfUseLinkText()}
                                                                </a>
                                                            ) : (
                                                                <a href={getTermsOfUseURL()} target="_blank">
                                                                    {getTermsOfUseLinkText()}
                                                                </a>
                                                            )}
                                                            {" "}
                                                            {tLang("registration.billing.terms-of-Use.terms-Text3")}{" "}
                                                            <a href={getPrivacyNoticeURL()} target="_blank">
                                                                {getPrivacyNoticeLinkText()}
                                                            </a>
                                                            {"."}
                                                        </p>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    {!isTypeSSOProvisional && (
                                        <Cart
                                            displayData={displayData}
                                            registrationLookup={registrationLookup}
                                            registrationState={registrationState}
                                            setRegistrationState={setRegistrationState}
                                            selectedCountry={watch("country")}
                                        />
                                    )}
                                </div>

                                    <div className="margin-vertical-l"></div>

                                    <div className="row between-xs">
                                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                                        <div className="col-xs col-no-gutter flex-grow-null">
                                            <ul className="list-inline list-reset">
                                                {ShowTermsAndConditionScreenFirst && !isTOSAccepted && (
                                                    <li className="margin-left-s">
                                                        <button
                                                            type="button"
                                                            className="btn-default
                                                    btn-default btn-min-width"
                                                            onClick={() => setPrevious()}
                                                        >
                                                            <span className="btn-text">{isPreviousOrBack}</span>
                                                        </button>
                                                    </li>
                                                )}
                                                <li className="margin-left-s">
                                                    <button
                                                        type="submit"
                                                        className="btn-default
                                            btn-primary btn-min-width"
                                                        onClick={onPersonalInfoNext}
                                                    >
                                                        <span className="btn-text">{isNextOrContinue}</span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {deviceVerificationStatus ?
                <Helmet>
                    <script src="js/config.js" type="text/javascript" ></script>
                    <script src="js/loader_only.js" type="text/javascript" ></script>
                </Helmet> :
                null
            }
        </>
    );
};

export default PersonalInformationForm;
